import { SignJWT } from "jose";

export async function createToken(body) {
  try {
    const payload = body;

    const secretKey = new TextEncoder().encode(
      process.env.NEXT_PUBLIC_JWT_SECRET_KEY
    );

    const token = await new SignJWT(payload)
      .setExpirationTime("3m")
      .setProtectedHeader({ alg: "HS256" })
      .sign(secretKey);

    return token;
  } catch (error) {
    return false;
  }
}
